// Which requesta.app links are a talent's page — the link a talent shares in
// iMessage / WhatsApp and the one their QR code holds. With the app installed,
// those open in the app (iPhone: public/.well-known/apple-app-site-association;
// Android 12+: the AppLinks alias in AndroidManifest.xml), so a fan who is
// signed in there requests under their own name.
//
//   /dj/:slug, /dj/:slug/request   the talent's profile and request page
//   /:slug                         the short link — any first segment the
//                                  app doesn't claim for its own routes
import { APP_FIRST_SEGMENTS } from "./customerPages";

// First segments that are not talent slugs but aren't app routes either:
// server and static paths, the talent emails' website-only /open/* doors,
// the SEO guides.
const NOT_A_SLUG = new Set(["api", "static", "assets", "open", "guides"]);

/** True for a talent page path ("/djlucky", "/dj/djlucky/request"). Query and hash are ignored. */
export const isTalentPagePath = (path: string): boolean => {
  const pathname = path.split(/[?#]/)[0];
  const segments = pathname.split("/").filter(Boolean);
  if (segments[0] === "dj") {
    return segments.length === 2 || (segments.length === 3 && segments[2] === "request");
  }
  if (segments.length !== 1) return false;
  const [slug] = segments;
  // A dot is a file (robots.txt, sitemap.xml) — slugs never have one.
  return !slug.includes(".") && !APP_FIRST_SEGMENTS.has(slug) && !NOT_A_SLUG.has(slug);
};

/** Where the app goes for a requesta.app link it was handed. Android claims
 *  every one-segment link (it can't list exceptions), so /app — "get the
 *  app" — lands on the app's home instead of bouncing to the App Store. */
export const inAppPath = (path: string): string => {
  const pathname = path.split(/[?#]/)[0];
  return pathname === "/app" ? "/" : path;
};
